var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 20,
    fill: "#FF6347"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 10,
    fill: "#4682B4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 10,
    fill: "#4682B4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 140,
    r: 5,
    fill: "#8B4513"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 160,
    r: 5,
    fill: "#8B4513"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 180,
    r: 5,
    fill: "#8B4513"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 140,
    r: 5,
    fill: "#8B4513"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 160,
    r: 5,
    fill: "#8B4513"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 180,
    r: 5,
    fill: "#8B4513"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 50,
    x2: 100,
    y2: 80,
    stroke: "#000",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 80,
    x2: 100,
    y2: 110,
    stroke: "#000",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 110,
    x2: 70,
    y2: 140,
    stroke: "#000",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 140,
    x2: 55,
    y2: 160,
    stroke: "#000",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 160,
    x2: 40,
    y2: 180,
    stroke: "#000",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 110,
    x2: 130,
    y2: 140,
    stroke: "#000",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 140,
    x2: 145,
    y2: 160,
    stroke: "#000",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 160,
    x2: 160,
    y2: 180,
    stroke: "#000",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtein);
export default __webpack_public_path__ + "static/media/protein.3f883f11abdc764b65b8aa6f348eb426.svg";
export { ForwardRef as ReactComponent };